import {
  Account,
  ConnectAdditionalRequest,
  TonProofItemReplySuccess,
} from '@tonconnect/ui'
import { callCheckProof } from '../helpers/api'

class BackendAuth {
  private readonly baseURL =
    'https://asia-east1-cards-collection-game.cloudfunctions.net'

  async generatePayload(): Promise<ConnectAdditionalRequest | undefined> {
    try {
      console.log('start generatePayload')
      const response = await (
        await fetch(`${this.baseURL}/auth-generatePayload`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            // Payload content here
          }),
        })
      ).json()
      return { tonProof: response.payload }
    } catch (e) {
      console.error(e)
      return
    }
  }

  async checkProof(
    proof: TonProofItemReplySuccess['proof'],
    account: Account
  ): Promise<string | undefined> {
    try {
      let pubKey = ''
      if (account.publicKey) {
        pubKey = account.publicKey
      }
      const requestBody = {
        address: account.address,
        network: account.chain,
        public_key: pubKey, // Added public_key
        proof: {
          ...proof,
          state_init: account.walletStateInit,
        },
      }

      const result = await callCheckProof(requestBody)

      if (result.success) {
        const customToken = result.response.data.customToken
        return customToken // Added return statement
      } else {
        console.error('Error from checkProof:', result.error)
        alert(`Error: ${result.error.message}`)
        return undefined // Optional: you can return undefined explicitly
      }
    } catch (e) {
      console.log(e)
      return undefined // Optional: you can return undefined explicitly
    }
  }

  async getAccountInfo(accessToken: string, account: Account) {
    return (
      await fetch(
        `${this.baseURL}/dapp/getAccountInfo?network=${account.chain}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
          },
        }
      )
    ).json()
  }
}

export const backendAuth = new BackendAuth()
